import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { dialogTypes } from '@/dialogs'
import { TdActions } from '@/components/tdActions'
import Icon from '@/components/Icon'

export const jobsGridButtons = (props) => {
  return class JobsCommandCell extends GridCell {
    handleDeleteClick () {
      props.openDialog({
        dialogType: dialogTypes.confirm,
        title: 'Common.Delete',
        content: 'Common.AreYouSure',
        primaryButtonText: 'Common.OK',
        onAction: () => { props.deleteUserJob(this.props.dataItem.id) }
      })
    }
    render () {
      return <TdActions>
        {props.canManage && <button className='btn-icon' onClick={() => props.editJob(prepareJobDto(this.props.dataItem))} title={props.localize('Common.Edit')}><Icon name='pencil' /></button>}
        {props.canManage && <button className='btn-icon' onClick={() => this.handleDeleteClick()} title={props.localize('Common.Delete')}><Icon name='x' /></button>}
      </TdActions>
    }
  }
}

export const inChargeOfInstitutionsGridButtons = (props) => {
  return class JobsCommandCell extends GridCell {
    handleDeleteClick () {
      props.openDialog({
        dialogType: dialogTypes.confirm,
        title: 'Common.Delete',
        content: 'Common.AreYouSure',
        primaryButtonText: 'Common.OK',
        onAction: () => { props.deleteEntity(this.props.dataItem.id) }
      })
    }
    render () {
      return <TdActions>
        <button className='btn-icon' onClick={() => props.edit(prepareInChargeDto(props.user.id, this.props.dataItem))} title={props.localize('Common.Edit')}><Icon name='pencil' /></button>
        <button className='btn-icon' onClick={() => this.handleDeleteClick()} title={props.localize('Common.Delete')}><Icon name='x' /></button>
      </TdActions>
    }
  }
}

const prepareJobDto = dataItem => ({
  id: dataItem.id,
  organizationalUnit: { id: dataItem.organizationalUnitId, name: dataItem.organizationalUnitName, latinName: dataItem.organizationalUnitLatinName },
  jobPosition: { id: dataItem.jobPositionId, name: dataItem.jobPositionName, latinName: dataItem.jobPositionLatinName },
  validFrom: dataItem.validFrom,
  validTo: dataItem.validTo,
  acting: dataItem.acting
})

const prepareInChargeDto = (userId, dataItem) => ({
  userId,
  id: dataItem.id,
  institution: { id: dataItem.institutionId, name: dataItem.institutionName, latinName: dataItem.institutionLatinName },
  responsibilityType: { id: dataItem.responsibilityTypeId, name: dataItem.responsibilityTypeName, latinName: dataItem.responsibilityTypeLatinName }
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/gridButtons.js